import React from 'react';

// components
import { Box } from '@brand/components';

import { CookieBanner } from 'components/organisms/CookieBanner';
import Footer from 'components/organisms/Footer';
import Navbar from 'components/organisms/Navbar';
import ComponentIsVisible from 'components/utils/IsVisible';

interface IBaseLayoutOrganism {
  children: React.ReactNode;
  hasFooter?: boolean;
  hasHeader?: boolean;
}

const BaseLayoutOrganism = ({
  children,
  hasFooter = true,
  hasHeader = true,
}: IBaseLayoutOrganism) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <ComponentIsVisible when={hasHeader}>
        <Navbar />
      </ComponentIsVisible>
      <Box as="main" flexGrow={1} minHeight="100%" role="main">
        {children}
      </Box>
      <ComponentIsVisible when={hasFooter}>
        <Footer />
      </ComponentIsVisible>
      <CookieBanner />
    </Box>
  );
};

export default BaseLayoutOrganism;
